<template>
  <main>
    <header>
      <img src="/assets/color-logo.svg" alt />
    </header>
    <div class="core-event-info">
      <div>
        <span>CoreEvent d.o.o</span>
        <span>Dunjevac 15, 10000 Zagreb</span>
      </div>
      <div>
        <span>Mail: <a href="mailto:contact@core-event.co">contact@core-event.co</a></span>
        <span>OIB: 36611335369</span>
        <span>IBAN: HR5223400091111141277</span>
      </div>
    </div>
    <hr />
    <div class="companies-info">
      <div v-if="organization" class="company-info">
        <span class="company-type">VJEROVNIK</span>
        <span>{{ organization.legalName }}</span>
        <span>OIB: {{ organization.OIB }}</span>
        <span>IBAN: {{ organization.IBAN }}</span>
        <span
          >Adresa: {{ organization.address }}, {{ organization.postalCode }}
          {{ organization.city }}</span
        >
      </div>
      <div class="company-info">
        <span class="company-type">DUŽNIK</span>
        <span>CoreEvent d.o.o.</span>
        <span>OIB: 36611335369</span>
        <span>IBAN: HR5223400091111141277</span>
        <span>Dunjevac 15, 10000 Zagreb, Hrvatska</span>
      </div>
    </div>
    <hr />
    <h1>
      Obračun ({{ formatDate(from) }} - {{ formatDate(to) }}) - {{ event.title }} (održan
      {{ formatDate(event.from) }})
    </h1>
    <table>
      <thead>
        <tr>
          <th>NAZIV</th>
          <th>CIJENA</th>
          <th>PROMO KOD</th>
          <th>POPUST</th>
          <th>PRODAJNO MJESTO</th>
          <th>UKUPNO</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(info, index) in purchaseInfo" :key="index">
          <td>{{ info.name }}</td>
          <td>{{ round(parseFloat(info.price)) }}&nbsp;EUR</td>
          <td>{{ info.promocode }}</td>
          <td>
            {{ round(parseFloat(info.discount)) }}
            {{ info.discountType === 'PERCENTAGE' ? '%' : 'EUR' }}
          </td>
          <td>{{ info.ticket_seller_name || 'ONLINE' }}</td>
          <td>{{ round(parseFloat(info.total)) }}&nbsp;EUR</td>
        </tr>
      </tbody>
      <tfoot />
    </table>
    <div class="total">
      <div>
        <span>Sveukupno:</span>
        <span> {{ (totalSoldAmount - (refundedOrders.amount || 0)).toFixed(2) }} EUR</span>
      </div>
      <div>
        <span>Osnovica:</span>
        <span>
          {{ (totalPriceWithoutVat - (refundedOrders.amountWithoutVat || 0)).toFixed(2) }} EUR
        </span>
      </div>
      <div>
        <span>PDV ({{ organization && organization.VATPercentage }}%):</span>
        <span>{{ vat }} EUR</span>
      </div>
    </div>
    <span>
      CoreEvent Provizija na ukupni iznos online prodaje ({{
        organization && organization.serviceFee
      }}%): {{ round(onlineSalesServiceFee) }} EUR
    </span>
    <p v-for="[fee, value] in Object.entries(coreEventOutletsSales)" v-bind:key="fee">
      Naknada za prodaju na CoreEvent fizičkim prodajnim mjestima ({{ value.feePercentage }}%):
      {{ round(totalCECashRegisterFee, 2) }} EUR
    </p>
    <p v-if="clientsCashRegisterSaleServiceFee > 0">
      Naknada za prodaju na fizičkim prodajnim mjestima klijenta ({{
        clientsCashRegisterSaleFeePercentage
      }}%): {{ round(clientsCashRegisterSaleServiceFee) }} EUR
    </p>
    <p>
      Ukupna provizija CoreEventa =
      {{ totalCoreEventFee }} + PDV (25%) = {{ round(totalCoreEventFee * 1.25) }} EUR
    </p>
    <div style="margin-top: 18px" />
    <button class="create-invoice">Kreiraj račun</button>
  </main>
</template>

<script>
import moment from 'moment'
import { round } from 'lodash'
import { GET_PURCHASE_SUMMARY } from '../../graphql/purchase.graphql'
import { exchangeRate } from '../../utils'

export default {
  props: {
    eventId: String,
    year: String,
    month: String,
  },
  data() {
    return {
      event: {},
      organization: null,
      exchangeRate: exchangeRate,
      purchaseInfo: [],
      to: '',
      from: '',
      totalSoldCount: '',
      totalSoldAmount: '',
      totalCoreEventFee: '',
      totalPriceWithoutVat: null,
      refundedOrders: {},
      vat: null,
      totalOnlineSales: 0,
      onlineSalesServiceFee: 0,
      totalCECashRegisterFee: 0,
      coreEventOutletsSales: [],
      totalClientsCashRegisterSale: 0,
      clientsCashRegisterSaleServiceFee: 0,
      clientsCashRegisterSaleFeePercentage: 0,
    }
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD. MM. YYYY')
    },
    round(num) {
      return Math.round(num * 100) / 100
    },
    formatDateTime(date) {
      return moment(date).format('DD. MM. YYYY HH:mm')
    },
    getYear(date) {
      return moment(date).year()
    },
  },
  apollo: {
    getPurchasesByEvent: {
      query: GET_PURCHASE_SUMMARY,
      variables() {
        return {
          eventId: this.eventId,
          from: this.year
            ? moment(`${this.year}/${this.month}`).startOf('month').format('YYYY-MM-DD HH:mm')
            : null,
          to: this.month
            ? moment(`${this.year}/${this.month}`).endOf('month').format('YYYY-MM-DD HH:mm')
            : null,
        }
      },
      manual: true,
      result({ data, loading }) {
        if (loading || !data.getPurchaseSummary) {
          return
        }
        const summary = data.getPurchaseSummary

        // Assign data directly from the backend
        this.event = summary.event
        this.organization = summary.event.organization
        this.from = this.year
          ? moment(`${this.year}/${this.month}`).startOf('month').format('YYYY-MM-DD HH:mm')
          : summary.from
        this.to = this.year
          ? moment(`${this.year}/${this.month}`).endOf('month').format('YYYY-MM-DD HH:mm')
          : summary.to
        const organizationVat = 1 + this.organization.VATPercentage / 100
        this.totalSoldCount = summary.totalSoldCount
        this.totalSoldAmount = summary.totalSoldAmount
        this.totalPriceWithoutVat = summary.totalPriceWithoutVat
        this.vat =
          summary.vat - (summary.refundInfo.amount - summary.refundInfo.amount / organizationVat)
        this.totalOnlineSales = summary.totalOnlineSales
        this.coreEventOutletsSales = summary.coreEventOutletsSales
        this.totalClientsCashRegisterSale = summary.totalClientsCashRegisterSale
        this.clientsCashRegisterSaleServiceFee = summary.clientsCashRegisterSaleServiceFee
        this.clientsCashRegisterSaleFeePercentage = summary.clientsCashRegisterSaleFeePercentage
        this.totalCECashRegisterFee = summary.totalCECashRegisterFee
        this.refundedOrders = {
          ...summary.refundInfo,
          amountWithoutVat: round(summary.refundInfo.amount / organizationVat, 2),
        }
        const refunded = { online: 0, amountOnline: 0, offline: 0, amountOffline: 0 }

        summary.purchaseInfo.length &&
          summary.purchaseInfo.map(info => {
            if (info.status !== 'SUCCESSFUL') {
              refunded.amountOffline += Number(info.offline)
              refunded.amountOnline += Number(info.online)
              refunded[Number(info.offline) ? 'offline' : 'online'] += Number(info.total)
              return
            }
            const existingItem = this.purchaseInfo.find(
              i =>
                i.event_id === info.event_id &&
                i.orderItemId === info.orderItemId &&
                i.promocodeid === info.promocodeid &&
                i.ticket_seller_name === info.ticket_seller_name,
            )
            if (existingItem) {
              existingItem.soldQuantity += info.soldQuantity
              existingItem.total += Number(info.total)
            } else {
              this.purchaseInfo.push({ ...info, total: Number(info.total) })
            }
          })

        const removeRefundedOrderCoreEventFeeOnline =
          refunded.online * ((Number(this.organization.serviceFee) || 0) / 100)

        const removeRefundedOrderCoreEventFeeOffline =
          refunded.offline * ((Number(this.organization.serviceFee) + 3 || 0) / 100)

        this.onlineSalesServiceFee =
          summary.onlineSalesServiceFee - removeRefundedOrderCoreEventFeeOnline

        this.totalCECashRegisterFee =
          summary.totalCECashRegisterFee - removeRefundedOrderCoreEventFeeOffline

        this.totalCoreEventFee = round(
          this.onlineSalesServiceFee +
            summary.clientsCashRegisterSaleServiceFee +
            this.totalCECashRegisterFee,
          2,
        )
        this.now = new Date()
      },
    },
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body {
  height: 100%;
}

main {
  /* border-right: 0.11111in dashed #0277bd; */
  height: 100%;
  /* margin-right: 1.333333in; */
  padding: 0.33333in 0.22222in 0.33333in 0.44444in;
}

header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.33333in;
}

hr {
  margin-bottom: 10px;
}

.core-event-info {
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.core-event-info > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.companies-info {
  margin-bottom: 10px;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
}

.companies-info > div {
  justify-content: space-between;
  display: flex;
  flex-direction: column;
}

.company-type {
  text-decoration: underline;
  margin-bottom: 10px;
}

.total {
  border-top: 1px solid;
  border-bottom: 1px solid;
  width: fit-content;
  margin: 15px 0;
}

.total > div {
  display: flex;
  width: 120%;
  justify-content: space-between;
}

.total > div span:nth-child(2) {
  font-weight: bold;
}

header img {
  height: 80px;
}

header span {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  text-align: right;
  color: #979797;
}

dl {
  margin-bottom: 0.33333in;
}

dl dt {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.11111in;
  line-height: 120%;
  color: #979797;
  margin-bottom: 0.02777in;
}

dl dd {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #666666;
}

dl dd + dt {
  margin-top: 0.11111in;
}

h1 {
  font-family: 'Raleway', sans-serif;
  font-weight: 800;
  font-size: 0.25in;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #333333;
}

table {
  width: 100%;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 0.13889in;
  line-height: 120%;
  color: #333333;
  border-collapse: collapse;
}

table thead {
  background: #e6f1f8;
}

table th {
  font-weight: normal;
  color: #0277bd;
}

table th,
table td {
  padding: 0.08333in 0.11111in;
}

table th:nth-child(-n + 3),
table tbody td:nth-child(-n + 3) {
  text-align: left;
}

table th:nth-child(n + 4),
table tbody td:nth-child(n + 4) {
  text-align: right;
}

table tfoot {
  background: #e6f1f8;
}

table tfoot td {
  color: #0277bd;
  text-align: right;
}

table tr:nth-child(even) {
  background: #f5f5f5;
}

@media print {
  .create-invoice {
    display: none !important;
  }
}

.create-invoice {
  background: #0277bd;
  color: white;
  font-weight: bold;
  padding: 10px;
  display: block;
  margin: 20px;
}
</style>
